import React, { useEffect } from 'react';
import { withCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Paper, TableContainer, TableHead, TableRow, TableCell, Table, TableBody, Button } from '@material-ui/core';
import ReactLoading from 'react-loading';

const headCells = [
    { id: 'requestDate', numeric: false, disablePadding: false, label: '送信日時', width: 'auto', textAlign: 'left' },
    { id: 'userId', numeric: false, disablePadding: false, label: 'ユーザーID', width: 'auto', textAlign: 'left' },
    { id: 'chatCategory', numeric: false, disablePadding: false, label: 'カテゴリ', width: 'auto', textAlign: 'left' },
    { id: 'chatTitle', numeric: false, disablePadding: false, label: 'タイトル', width: 'auto', textAlign: 'left' },
    { id: 'message', numeric: false, disablePadding: false, label: 'メッセージ内容', width: 'auto', textAlign: 'left' },
    { id: 'state', numeric: false, disablePadding: false, label: '状態', width: 'auto', textAlign: 'left' },
    { id: 'button   ', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left' }
];

const styles = () => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        marginTop: '20px',
        minWidth: 1200
    },
    tableHeadColor: {
        backgroundColor: '#edeff0',
        borderColor: '#dee2e6',
        color: '#495057',
    },
    table: {
        minWidth: 1000,
    },
    cell: {
        display: 'block',
    },
    center: {
        justifyContent: 'center',
        alignItems:'center',
        margin: '50px auto 50px auto',
    }
});

function MessageLogTableHead(props) {
    const { classes, order, orderBy, header, inchatName } = props;

    return (
        <TableHead className={classes.tableHeadColor}>
            <TableRow>
                {header.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        { headCell.id === 'state' ? `${inchatName}${headCell.label}` : headCell.label }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

const MessageLogTable = withCookies((props) => {
    const { cookies, classes, datas, addressFlg, setFullTextDisplayData, setFullTextDisplayFlg, isLoading } = props;
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('requestDate');
    const [header, setHeader] = React.useState(headCells);
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const inchatName = chatNameObj !== undefined ? chatNameObj.INCHAT_NAME : 'チャット';
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'カテゴリ';
    const addressName = chatNameObj !== undefined ? chatNameObj.ADDRESS_NAME : '宛名番号';
    const userName = chatNameObj !== undefined ? chatNameObj.USER_NAME : 'ニックネーム';
    useEffect(() => {
        const copyHeader = header;
        if(addressFlg){
            copyHeader[2].label = kubunName;
            const addressNumberHeader = {
                'id': 'addressNumber',
                'numeric': false,
                'disablePadding': false,
                'label': addressName,
                'width': 'auto',
                'textAlign': 'left'
            };
            const nickNameHeader = {
                'id': 'nickName',
                'numeric': false,
                'disablePadding': false,
                'label': userName,
                'width': 'auto',
                'textAlign': 'left'
            };
            copyHeader.splice(3, 0 , addressNumberHeader, nickNameHeader);
        }
        setHeader(copyHeader);
    }, []);
    const handleRequestSort = (_event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const truncateString = (str) => {
        if (str.length > 10) {
            return str.substring(0, 10) + '...';
        }
        else {
            return str;
        }
    }

    const fullTextDisplay = (data) => {
        setFullTextDisplayFlg(true);
        setFullTextDisplayData(data);
    }

    return (
        <React.Fragment>
            { isLoading ? (
                <ReactLoading
                    className={classes.center}
                    type={'spin'}
                    color={'black'}
                    height={'50px'}
                    width={'50px'}
                />
            )
            :
            (
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="draft table">
                            <MessageLogTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={datas.length}
                                addressFlg={addressFlg}
                                header={header}
                                inchatName={inchatName}
                            />
                            <TableBody>
                                {datas.map((data, index) => {
                                    const labelId = `deliveryError-data-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            // key={data.recordId}
                                            key={data.chatId}
                                        >
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[0].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.requestDate}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[1].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[1].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.userId}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[2].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[2].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.chatCategory}</p>
                                                </div>
                                            </TableCell>
                                            { addressFlg && (
                                                <>
                                                    <TableCell
                                                        component="th"
                                                        id={labelId}
                                                        // scope='row'
                                                        padding={headCells[3].disablePadding ? 'none' : 'default'}
                                                        align={'center'}
                                                        style={{ minWidth: '30px', textAlign: headCells[3].textAlign }}
                                                    >
                                                        <div className={classes.cell}>
                                                            <p>{data.addressNumber}</p>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        id={labelId}
                                                        // scope='row'
                                                        padding={headCells[4].disablePadding ? 'none' : 'default'}
                                                        align={'center'}
                                                        style={{ minWidth: '30px', textAlign: headCells[4].textAlign }}
                                                    >
                                                            <div className={classes.cell}>
                                                                <p>{data.nickName}</p>
                                                            </div>
                                                    </TableCell>
                                                </>
                                            )}
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[0].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{truncateString(data.chatTitle)}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[0].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{truncateString(data.message)}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[0].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.chatState}</p>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '30px', textAlign: headCells[0].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <Button variant='contained' onClick={() => fullTextDisplay(data)}>{'全文表示'}</Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
        </React.Fragment>
    );
});

MessageLogTable.propTypes = {
    classes: PropTypes.object.isRequired,
    datas: PropTypes.array.isRequired,
    addressFlg: PropTypes.bool.isRequired,
    setFullTextDisplayData: PropTypes.func.isRequired,
    setFullTextDisplayFlg: PropTypes.func.isRequired,
};

MessageLogTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
};

export default withStyles(styles)(MessageLogTable);